'use strict';

/**
 * TEMPORARY QA utility: flag for disabling contextual loading (e.g. profile, cart, wishlist
 * population via JS). Not account-specific; used by any feature that loads context after page load.
 *
 * SHOP-4393: Implemented as a temporary utility. A follow-up ticket MUST be scheduled to remove
 * this module and all usages 60 days post-launch. On removal: delete this file, remove the
 * require() from public/js/deps/main.js, and remove isContextualLoadingDisabled checks from
 * consumers (e.g. account-profile.js).
 */

/** localStorage key and query param for disabling contextual loading */
const QA_DISABLE_CONTEXTUAL_LOADING_KEY = 'disable_contextual_loading';
const QA_QUERY_PARAM = 'disable-contextual-loading';

/**
 * Sync disable_contextual_loading from query string to localStorage on page load.
 * ?disable-contextual-loading=1 sets the flag (disable JS population); =0 clears it.
 * Run once when module loads so flag is set before any contextual loading runs.
 *
 * @param {string} [search] Optional query string (e.g. window.location.search). Omit to use current location.
 */
function syncDisableContextualLoadingFromQueryString(search) {
	try {
		const queryString =
			typeof search === 'string'
				? search
				: typeof window !== 'undefined' && window.location && window.location.search
					? window.location.search
					: '';
		if (!queryString) {
			return;
		}
		const params = new URLSearchParams(queryString);
		const value = params.get(QA_QUERY_PARAM);
		if (value === '1') {
			localStorage.setItem(QA_DISABLE_CONTEXTUAL_LOADING_KEY, '1');
		} else if (value === '0') {
			localStorage.setItem(QA_DISABLE_CONTEXTUAL_LOADING_KEY, '0');
		}
	} catch (e) {
		// ignore
	}
}

syncDisableContextualLoadingFromQueryString();

/**
 * Check if contextual loading is disabled (for QA testing).
 * @returns {boolean}
 */
function isContextualLoadingDisabled() {
	try {
		return localStorage.getItem(QA_DISABLE_CONTEXTUAL_LOADING_KEY) === '1';
	} catch (e) {
		return false;
	}
}

module.exports = {
	isContextualLoadingDisabled,
	syncDisableContextualLoadingFromQueryString,
};
